import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';

import { Timer } from 'easytimer.js';
import { numberRandom } from '../helpers';

@Component({
  selector: 'app-utils-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnChanges {

  timer: any;
  intervarTimer: any;

  @Input() viewTimer: boolean;
  @Input() styles = {};
  @Input() determinate: boolean;
  @Input() progress: any;
  @Input() color = 'primary';
  @Input() spinner: boolean;
  @Input() spinnerWidth: number;
  @Input() message: string;
  @Input() classMessage: string;
  @Input() classTimer: string;
  @Input() progressCalc: number;

  constructor() { }

  ngOnInit() {
    if (this.spinnerWidth) {
      this.styles = {
        'width': `${this.spinnerWidth}px`,
        'height': `${this.spinnerWidth}px`
      };
    }

    if (this.viewTimer) {
      this.timer = new Timer();
      this.timer.start();
    }

    if (this.progressCalc) {
      this.intervarTimer = setInterval(() => {
        if (this.progress < 100) {
          this.progress = numberRandom(this.progress, this.progress + 10);
          if (this.progress > 90) {
            this.progress = numberRandom(91, 99);
            clearInterval(this.intervarTimer);
          }
        } else {
          clearInterval(this.intervarTimer);
        }
      }, this.progressCalc);
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['progress']) {
      this.progress = changes['progress'].currentValue;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/progress-bar/progress-bar.component.ts